import { render, staticRenderFns } from "./LogsTables.vue?vue&type=template&id=356a12b3&scoped=true"
import script from "./LogsTables.vue?vue&type=script&lang=js"
export * from "./LogsTables.vue?vue&type=script&lang=js"
import style0 from "./LogsTables.vue?vue&type=style&index=0&id=356a12b3&prod&scoped=true&lang=css"
import style1 from "./LogsTables.vue?vue&type=style&index=1&id=356a12b3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a12b3",
  null
  
)

export default component.exports